module.exports = __webpack_public_path__ + "static/github-file-default-414f3cc0c0af5aa8b834ee5dfa29cb6a.png";